import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import Card from "./Card";

export function ToggleCard({ title, options, isLoading }) {
    const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <Card>
            <Card.CHeader>
                {title && <Card.Header.Title>{t(title)}</Card.Header.Title>}
                <Card.Header.Buttons>
                    {options.map((option, idx) => (
                        <button
                            key={idx}
                            type="button"
                            className={`btn btn-sm btn-default skynet-sub-border${activeIndex === idx ? " active" : ""}`}
                            onClick={e => {
                                e.stopPropagation();
                                setActiveIndex(idx);
                            }}
                        >
                            {t(option.title)}
                        </button>
                    ))}
                </Card.Header.Buttons>
            </Card.CHeader>
            <Card.Content isLoading={isLoading}>
                {options[activeIndex].content}
            </Card.Content>
        </Card>
    );
}